module.exports = __webpack_public_path__ + "img/APP-applet.1691208c.png";